import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import common from 'locales/ko/common.json';
import commonInfReport from 'locales/ko/commonInfReport.json';
import commonModal from 'locales/ko/commonModal.json';
import commonTable from 'locales/ko/commonTable.json';
import infReportInstagram from 'locales/ko/infReportInstagram.json';
import infReportNaverBlog from 'locales/ko/infReportNaverBlog.json';
import infReportTiktok from 'locales/ko/infReportTiktok.json';
import infReportTwitter from 'locales/ko/infReportTwitter.json';
import infReportYoutube from 'locales/ko/infReportYoutube.json';

const resources = {
	ko: {
		common,
		commonInfReport,
		commonModal,
		commonTable,
		infReportInstagram,
		infReportNaverBlog,
		infReportTiktok,
		infReportTwitter,
		infReportYoutube,
	},
} as const;

i18n.use(initReactI18next).init({
	resources,
	debug: true,
	lng: 'ko', // 기본 설정 언어, 'cimode'로 설정할 경우 키 값으로 출력된다.
	fallbackLng: 'ko', // 번역 파일에서 찾을 수 없는 경우 기본 언어
	defaultNS: 'common',
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
